import React from 'react';
import TweetCard from './TweetCard';
import RedditCard from './RedditCard';
import RoamQuoteCard from './RoamQuoteCard';
import { isRoamSource } from '../utils';

/**
 * TweetList component for displaying tweets with pagination
 */
const TweetList = ({ 
  tweets, 
  onLoadMore, 
  hasMoreTweets,
  onTweetUpdate 
}) => {
  
  // Render individual tweet or Reddit post
  const renderItem = (item, index) => {
    if (!item) return null;

    // Use a combination of id and index to ensure uniqueness
    const uniqueKey = `${item.source || 'tweet'}-${item.id}-${index}`;

    if (item.source === 'reddit') {
      return <RedditCard key={uniqueKey} post={item} />;
    }

    if (isRoamSource(item.source)) {
      return <RoamQuoteCard key={uniqueKey} quote={item} />;
    }

    return (
      <TweetCard
        key={uniqueKey}
        tweet={item}
        onUpdateTweet={onTweetUpdate}
        onEditStateChange={() => {}} // No-op for now
      />
    );
  };
  
  return (
    <>
      <div className="tweet-list">
        {tweets.map((item, index) => renderItem(item, index))}
      </div>

      {hasMoreTweets && (
        <button
          onClick={onLoadMore}
          className="load-more-button"
          aria-label="Load more tweets"
        >
          Load More
        </button>
      )}
    </>
  );
};

export default TweetList;